import {
    Icon,
    IconButton
} from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { StandardTable } from '../../_components/table/standard.table';
import { PaperTableHeader } from '../../_components/table/header.table';
import { TABLE_FILTER } from '../../_const/tableFilter.const';
import { handleErrorResponse } from '../../_helpers/handleResponse.helper';
import { SearchTableHeader } from '../../_components/table/search.table';
import { deletedClientService } from '../../_services/deletedClient.service';
import { getDateString } from '../../_helpers/dateTime.helper';
import { Button } from '@mantine/core';
import { useTheme } from "@mui/material/styles";

export function DeletedClientIndex() {
    const [data, setData] = useState<any>({ items: [], count: 10 });
    const [filter, setFilter] = useState({ ...TABLE_FILTER });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const fetchData = async () => {
        setIsLoading(true);
        return await deletedClientService.getAll(filter)
            .then(
                json => {
                    setData(json);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [filter]);

    const theme = useTheme();
    const brandPrimary = theme.palette.primary.main;

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'id',
                header: 'ID',
            },
            {
                accessorKey: 'name',
                header: 'Name',
            },
            {
                accessorKey: 'deletedBy',
                header: 'Deleted By',
            },
            {
                accessorKey: 'deletedDate',
                header: 'Deleted Date',
                Cell: ({ row }) => (
                    <>{!!row.original.deletedDate ? getDateString(row.original.deletedDate) : ""}</>
                ),
            },
            {
                id: 'reports',
                header: '',
                enableColumnActions: false,
                Cell: ({ row }) => (
                    <Button
                        onClick={() => {}}>
                        View Report
                    </Button>
                ),
            },
        ],
        []
    );

    return (
        <>
            <PaperTableHeader title="Deleted Clients"/>

            <SearchTableHeader inputs={[
                { label: "Name", name: "name", onChange: setFilter, value: filter.name },
            ]} />

            <StandardTable
                columns={columns}
                data={data}
                filter={filter}
                setFilter={setFilter}
                loading={isLoading}
            />

        </>
    );
}
